import { useEffect, useState } from 'react';
import FilterSelectField from '../FilterSelectField';
import cross from '../../assets/logo/cross.svg';
import { StyledModal } from '../FilterDrawer/styles';
import { MobileFilterNavDiv } from '../FilterMobileDrawer/styles';
import Skeleton from 'react-loading-skeleton';
import {
  fetchCoverageTypes,
  fetchQuoteStages,
  fetchQuoteStatus,
  fetchQuoteTypes,
} from '../../api/quote';
import Modal from '../Modal';
import { IOption } from '../../interfaces/Opportunity';

const QuotesFilter = ({
  show,
  closeModal,
  filterFunction,
  selectedQuoteType,
  setSelectedQuoteType,
  selectedQuoteStatus,
  setSelectedQuoteStatus,
  selectedQuoteStage,
  setSelectedQuoteStage,
  selectedCoverageType,
  setSelectedCoverageType,
}: {
  show: string;
  closeModal: Function;
  filterFunction: Function;
  selectedQuoteType?: IOption;
  setSelectedQuoteType: Function;
  selectedQuoteStatus?: IOption;
  setSelectedQuoteStatus: Function;
  selectedQuoteStage: IOption[];
  setSelectedQuoteStage: Function;
  selectedCoverageType: IOption[];
  setSelectedCoverageType: Function;
}) => {
  const onCloseModal = () => {
    closeModal('closing');
    setTimeout(() => {
      closeModal('closed');
    }, 300);
  };

  const [loadingStatus, setLoadingStatus] = useState('idle');

  const [quoteStage, setQuoteStage] = useState<any[]>([]);
  const [quoteStatus, setQuoteStatus] = useState<any[]>([]);
  const [quoteType, setQuoteType] = useState<any[]>([]);
  const [coverageType, setCoverageType] = useState<any[]>([]);

  useEffect(() => {
    if (loadingStatus === 'idle' || loadingStatus === 'succeeded') {
      // setLoadingStatus('loading');
      filterFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedQuoteType,
    selectedCoverageType,
    selectedQuoteStatus,
    selectedQuoteStage,
  ]);

  useEffect(() => {
    setLoadingStatus('loading');
    fetchQuoteStages((data: any[]) => {
      setQuoteStage(data);
      setLoadingStatus('succeeded');
    });
  }, []);

  useEffect(() => {
    setLoadingStatus('loading');
    fetchQuoteTypes((data: []) => {
      setQuoteType(data);
      setLoadingStatus('succeeded');
    });
    fetchQuoteStatus((data: []) => {
      setQuoteStatus(data);
      setLoadingStatus('succeeded');
    });
  }, []);

  useEffect(() => {
    setLoadingStatus('loading');
    fetchCoverageTypes((data: []) => {
      setCoverageType(data);
      setLoadingStatus('succeeded');
    });
  }, []);

  const filterContent = () => {
    return (
      <>
        <div>
          <h6 className='head text-uppercase'>Quote Stage</h6>
        </div>
        {loadingStatus === 'loading' ? (
          <Skeleton height={48} />
        ) : (
          <div className='agency-fields'>
            <FilterSelectField
              options={quoteStage.map((item: any) => {
                return {
                  label:
                    item.name?.charAt(0).toUpperCase() +
                    item.name?.toLowerCase().slice(1),
                  value: item.uuid,
                };
              })}
              placeholder='Select'
              onChange={(value: any) => {
                setSelectedQuoteStage(value);
              }}
              isMulti={true}
              value={selectedQuoteStage}
            />
          </div>
        )}
        <hr className='filter-hr' />
        <div>
          <h6 className='head text-uppercase'>Quote Type</h6>
        </div>
        {loadingStatus === 'loading' ? (
          <Skeleton height={48} />
        ) : (
          <div className='agency-fields'>
            <FilterSelectField
              options={quoteType.map((item: any) => {
                return {
                  label:
                    item.name?.charAt(0).toUpperCase() +
                    item.name?.toLowerCase().slice(1),
                  value: item.uuid,
                };
              })}
              placeholder='Select'
              onChange={(value: any) => {
                setSelectedQuoteType(value);
              }}
              value={selectedQuoteType}
            />
          </div>
        )}

        <hr className='filter-hr' />
        <div>
          <h6 className='head text-uppercase'>Quote Status</h6>
        </div>
        {loadingStatus === 'loading' ? (
          <Skeleton height={48} />
        ) : (
          <div className='agency-fields'>
            <FilterSelectField
              options={quoteStatus.map((item: any) => {
                return {
                  label:
                    item.name?.charAt(0).toUpperCase() +
                    item.name?.toLowerCase().slice(1),
                  value: item.uuid,
                };
              })}
              placeholder='Select'
              onChange={(value: any) => {
                setSelectedQuoteStatus(value);
              }}
              value={selectedQuoteStatus}
            />
          </div>
        )}

        <hr className='filter-hr' />
        <div>
          <h6 className='head text-uppercase'>Coverage Type</h6>
        </div>
        {loadingStatus === 'loading' ? (
          <Skeleton height={48} />
        ) : (
          <div className='agency-fields'>
            <FilterSelectField
              options={coverageType.map((item: any) => {
                return {
                  label:
                    item.name?.charAt(0).toUpperCase() +
                    item.name?.toLowerCase().slice(1),
                  value: item.uuid,
                };
              })}
              placeholder='Select'
              onChange={(value: any) => {
                setSelectedCoverageType(value);
              }}
              isMulti={true}
              value={selectedCoverageType}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div className='d-none d-sm-block'>
        <Modal open={show} align='right'>
          <StyledModal>
            <button className='crossbutton' onClick={() => onCloseModal()}>
              <img src={cross} className='cross' alt='cross-icon' />
            </button>
            <div>
              <h2>Filters</h2>
            </div>
            <div>
              <hr className='filter-hr' />
            </div>
            <div>
              <div>
                {show && (
                  <div>
                    <div className='field-section'>{filterContent()}</div>
                    <div className='buttonsDiv filterButtonContainer d-flex align-items-center justify-content-between'>
                      <div className='filter-count'>
                        {selectedQuoteStage?.length +
                          selectedCoverageType?.length +
                          (selectedQuoteStatus?.value ? 1 : 0) +
                          (selectedQuoteType?.value ? 1 : 0)}{' '}
                        filters added
                      </div>
                      <button
                        type='submit'
                        className='agentButton justify-content-end'
                        onClick={() => {
                          setSelectedQuoteStatus([]);
                          setSelectedCoverageType([]);
                          setSelectedQuoteType([]);
                          setSelectedQuoteStage([]);
                        }}
                        disabled={
                          selectedQuoteStage?.length +
                            selectedCoverageType?.length +
                            (selectedQuoteStatus?.value ? 1 : 0) +
                            (selectedQuoteType?.value ? 1 : 0) ===
                          0
                        }
                      >
                        Clear all filters
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </StyledModal>
        </Modal>
      </div>
      <div className='d-block d-sm-none'>
        <MobileFilterNavDiv>
          <div className='backgroundQuickAdd'>
            <div className={`quickFormsDropDown closed`}>
              <div className='d-flex  drawerHandle'></div>
              <h2>Filters</h2>
              <button className='crossbutton' onClick={() => onCloseModal()}>
                <img src={cross} className='cross' alt='cross-icon' />
              </button>
              <div className='scroll-filter-mob'>
                {filterContent()}
                <div className='buttonsDiv d-flex align-items-center justify-content-between'>
                  <div className='filter-count'>
                    {selectedQuoteStage?.length +
                      selectedCoverageType?.length +
                      (selectedQuoteStatus?.value ? 1 : 0) +
                      (selectedQuoteType?.value ? 1 : 0)}{' '}
                    filters added
                  </div>
                  <button
                    type='submit'
                    className='agentButton justify-content-end'
                    onClick={() => {
                      setSelectedQuoteStatus([]);
                      setSelectedCoverageType([]);
                      setSelectedQuoteType([]);
                      setSelectedQuoteStage([]);
                    }}
                    disabled={
                      selectedQuoteStage?.length +
                        selectedCoverageType?.length +
                        (selectedQuoteStatus?.value ? 1 : 0) +
                        (selectedQuoteType?.value ? 1 : 0) ===
                      0
                    }
                  >
                    Clear all filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </MobileFilterNavDiv>
      </div>
    </>
  );
};

export default QuotesFilter;
